import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { Scan } from '../modules/scanning/Scan'
import { Analytics } from '../modules/analytics/Analytics'
import { Logout } from '../modules/authentication/Logout'
import Parcels from "../modules/bags/Parcels";

export const AuthRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path={'/scan'} element={<Scan />} />
      <Route path={'/analytics'} element={<Analytics />} />
      <Route path={'/parcels'} element={<Parcels />} />
      <Route path={'/logout'} element={<Logout />} />
      <Route path={'*'} element={<Navigate to={'/scan'} />} />
    </Routes>
  )
}
